module.exports = __webpack_public_path__ + "img/filter-welcome-background-hyundai.afea92a8.png";